import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, " Alterar Comunicado ", -1)
const _hoisted_3 = {
  key: 0,
  class: "col-md-12 mb-4"
}
const _hoisted_4 = {
  key: 0,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_5 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Titulo", -1)
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Descrição", -1)
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Observação", -1)
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "URL", -1)
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = ["value"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, " É um card?", -1)
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, " Se é card, vai ficar fixo no TOPO?", -1)
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, "Image", -1)
const _hoisted_22 = { class: "input-group" }
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-secondary" }, "Salvar", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageUploadcp = _resolveComponent("ImageUploadcp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    ($setup.data.msg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          ($setup.data.success)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.data.msg), 1))
            : _createCommentVNode("", true),
          ($setup.data.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.data.msg), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.short_name) = $event)),
          class: "form-control",
          name: "short_name"
        }, null, 512), [
          [_vModelText, $setup.data.short_name]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.long_name) = $event)),
          class: "form-control",
          name: "long_name"
        }, null, 512), [
          [_vModelText, $setup.data.long_name]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.note) = $event)),
          class: "form-control",
          name: "note"
        }, null, 512), [
          [_vModelText, $setup.data.note]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.url) = $event)),
          class: "form-control",
          name: "url"
        }, null, 512), [
          [_vModelText, $setup.data.url]
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.iscard) = $event)),
          class: "form-check-input",
          type: "checkbox",
          value: `${$setup.data.iscard}`,
          id: "flexCheckDefault",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.checkiscard($setup.data.iscard)))
        }, null, 8, _hoisted_15), [
          [_vModelCheckbox, $setup.data.iscard]
        ]),
        _hoisted_16
      ]),
      _createElementVNode("div", _hoisted_17, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.iscardtop) = $event)),
          class: "form-check-input",
          type: "checkbox",
          value: `${$setup.data.iscardtop}`,
          id: "flexCheckDefault",
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.checkiscardtop($setup.data.iscardtop)))
        }, null, 8, _hoisted_18), [
          [_vModelCheckbox, $setup.data.iscardtop]
        ]),
        _hoisted_19
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.data.image) = $event)),
            class: "form-control",
            name: "image"
          }, null, 512), [
            [_vModelText, $setup.data.image]
          ]),
          _createVNode(_component_ImageUploadcp, {
            tipo: 3,
            onUploaded: _cache[9] || (_cache[9] = ($event: any) => ($setup.data.image = $event))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("img", {
          src: `${$setup.data.serverimg}${$setup.data.image}`,
          width: "200"
        }, null, 8, _hoisted_24)
      ]),
      _hoisted_25
    ], 32)
  ]))
}